import React, { useState, useLayoutEffect, useEffect, useRef } from 'react';
import { Menu, Layout } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined } from '@ant-design/icons';
import { pushHistory } from '../../common/util';
import Right from './right-menu';

import styles from './index.less';
console.log(styles.main);

function getFirstChildPath(pathItem) {
  const { subMenus: children } = pathItem;
  if (!children || children.length === 0) {
    return pathItem.url;
  }
  return getFirstChildPath(children[0]);
}

export default ({
  collapsed,
  avatarMenu = [],
  onClickAvatarMenu,
  onCollapseMenu,
  currentUser = {},
  menus = [],
  schools = [],
  onActiveChange,
  loading
}) => {
  const menuList = (menus || []).map(({ menuName, url }) => {
    return { menuName, url };
  });

  const { pathname } = location;
  const $header = useRef(null);
  const $titleWrapper = useRef(null);
  const $right = useRef(null);
  const [menuWidth, setMenuWidth] = useState('0');
  const [activeIndex, setActiveIndex] = useState(0);

  function updateMenuWidth() {
    if (!($header.current && $titleWrapper.current && $right.current)) return;
    setMenuWidth($header.current.getBoundingClientRect().width - $titleWrapper.current.getBoundingClientRect().width - $right.current.getBoundingClientRect().width + 'px');
  }
  useLayoutEffect(() => {
    updateMenuWidth();
    window.addEventListener('resize', updateMenuWidth);
    return () =>
      window.removeEventListener('resize', updateMenuWidth);
  }, []);
  useEffect(() => {
    const pathRegex = new RegExp('^\\' + pathname.match(/^\/[^/]*/)[0] + '(\\/|$)');
    const matchedActiveIndex = menuList.findIndex(({ url }) => {
      return pathRegex.test(url);
    });
    updateActiveIndex(matchedActiveIndex === -1 ? 0 : matchedActiveIndex);
  }, [pathname, menuList]);
  const updateActiveIndex = (index) => {
    setActiveIndex(index);
    onActiveChange(index);
  };

  const handleSelect = ({ item: { props: { index }}, key }) => {
    const { subMenus: subMenuList = [] } = menus[index];
    updateActiveIndex(index);

    // 点击菜单后，自动跳转到第一个子项path
    if (subMenuList.length) {
      const locaPath = getFirstChildPath(subMenuList[0]);

      if (/^http/.test(locaPath || '')) {
        window.open(locaPath);
        return null;
      }
      pushHistory(locaPath);
    } else {
      pushHistory(key);
    }
  };

  return (
    <div ref={$header}>
      <Layout.Header
        id="nbugs-main-container-header"
        style={{
          lineHeight: '56px',
          height: '56px',
          width: '100 %',
          background: '#1785ec',
          display: 'flex',
          padding: 0,
        }}>
        <div className={styles.titleWrapper} ref={$titleWrapper}>
          {
            collapsed ? <MenuUnfoldOutlined className={styles.trigger} onClick={onCollapseMenu} />
              : <MenuFoldOutlined className={styles.trigger} onClick={onCollapseMenu} />
          }
          <span className={styles.subtitle}>{currentUser.schoolName}</span>
        </div>
        <div className={styles.rightWrapper}>
          <Menu
            className={styles.menu}
            mode="horizontal"
            theme="dark"
            selectedKeys={activeIndex === -1 ? [] : [menuList[activeIndex] && menuList[activeIndex].url]}
            onSelect={handleSelect}
            style={{
              background: 'transparent',
              color: '#fff',
              borderBottom: 0,
              overflow: 'visible',
              maxWidth: menuWidth,
            }}
          >
            {menuList.map(({ menuName, url, subMenus }, index) => {
              return (
                <Menu.Item className={styles.menuItem} key={url} title={menuName} index={index}
                  style={{
                    color: '#fff',
                    borderBottom: 0,
                  }}
                >
                  {menuName}
                </Menu.Item>
              );
            })}
          </Menu>
          <div
            className={styles.right}
            ref={$right}
          >
            <Right
              currentUser={currentUser}
              schools={schools}
            />
          </div>
        </div>
      </Layout.Header >
    </div>
  );
};
